const apiPath = "/customs/customs-expense-revenues";
const path = "CustomsExpensesIncomesModule";

const CustomsExpensesIncomesAPIsConstants = {
  API_PATH: `${apiPath}`,
};

const CustomsExpensesIncomesActions = {
  ADD_ITEM: `${path}/addItem`,
  UPDATE_ITEM: `${path}/updateItem`,
  EDIT_ITEM: `${path}/editItem`,
  FIND_ITEM_BY_ID: `${path}/findItemById`,
  GET_INIT_DATA : `${path}/getInitData`,
};

export { CustomsExpensesIncomesAPIsConstants, CustomsExpensesIncomesActions };
